import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import configs from '../axios.config'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

import notify from './mixins/notify'
import fileRequest from './mixins/fileRequest'
import globalVariables from '@/mixins/globalVariables'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/acl'
import objective from './mixins/objective'
import areYouSure from './mixins/areYouSure'
import dayjs from 'dayjs'
import VueNativeSock from 'vue-native-websocket'


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// миксин уведомлений
Vue.mixin(notify)

// миксин fileRequest
Vue.mixin(fileRequest)
Vue.mixin(globalVariables)
Vue.mixin(objective)
Vue.mixin(areYouSure)




// Composition API
Vue.use(VueCompositionAPI)

let token
if(localStorage.getItem('accessWAREHOUSE')){
  token = localStorage.getItem('accessWAREHOUSE')
}

// websocket
Vue.use(VueNativeSock, configs.webSocket + '?token=' + token, {
  connectManually: true,
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false;
Vue.prototype.$dayjs = dayjs;

Vue.directive('button-disable', {
  bind(el, binding) {
    console.log(el)
    // Code to change the text color dynamically 
  }
})








new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
